import { NavLink, Outlet } from 'react-router-dom';
import { cx } from 'class-variance-authority';
import { Bot, Plug, Link2, Users, FileCheck, BarChart3, type LucideIcon } from 'lucide-react';

const workspaceNavItems: { label: string; to: string; icon: LucideIcon }[] = [
  { label: 'LLM Configuration', to: '/settings/workspace/llm', icon: Bot },
  { label: 'Integrations', to: '/settings/workspace/integrations', icon: Plug },
  { label: 'Connectors', to: '/settings/workspace/connectors', icon: Link2 },
  { label: 'Approval Roles', to: '/settings/workspace/approvals', icon: Users },
  { label: 'Policy', to: '/settings/workspace/policy', icon: FileCheck },
  { label: 'Observability', to: '/settings/workspace/observability', icon: BarChart3 },
];

export const WorkspaceSection = () => {
  return (
    <div className="flex h-full min-h-0">
      {/* Sub-sidebar */}
      <aside className="w-56 shrink-0 border-r border-neutral-200/80 bg-neutral-50/50 flex flex-col">
        <div className="px-4 py-4 border-b border-neutral-200/80">
          <h2 className="text-sm font-semibold text-neutral-900">Workspace</h2>
          <p className="text-xs text-neutral-500 mt-0.5">LLM, integrations & policy</p>
        </div>

        <nav className="flex-1 py-2 px-2 overflow-y-auto">
          {workspaceNavItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  cx(
                    'flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors',
                    isActive
                      ? 'bg-blue-500/10 text-blue-700 font-medium'
                      : 'text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900',
                  )
                }
              >
                <IconComponent className="w-4 h-4 shrink-0" strokeWidth={2} aria-hidden />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
      </aside>

      {/* Main content */}
      <main className="flex-1 min-w-0 overflow-auto bg-white">
        <Outlet />
      </main>
    </div>
  );
};
